import { render, staticRenderFns } from "./CellRendererCrewCard.vue?vue&type=template&id=10555129&scoped=true"
import script from "./CellRendererCrewCard.vue?vue&type=script&lang=js"
export * from "./CellRendererCrewCard.vue?vue&type=script&lang=js"
import style0 from "./CellRendererCrewCard.vue?vue&type=style&index=0&id=10555129&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10555129",
  null
  
)

export default component.exports